 <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.add_contracts' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.add_contracts_list' | translate }}</p>
          </div>
        </div>


<div class="card">
  <div class="card-body">
   <form #contractForm="ngForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
  <div class="row">

    <!-- User -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label required-field">{{ 'MENU.DASHBOARD.user_name' | translate }}</label>
        <select
          class="form-control"
          [(ngModel)]="formData.user_id"
          name="user_id"
          #user_id="ngModel"
          [class.is-invalid]="user_id.invalid && user_id.touched"
          required
        >
          <option value="" disabled selected>
            {{ 'MENU.DASHBOARD.select_user' | translate }}
          </option>
          <option *ngFor="let item of InvestorsId" [value]="item.id">
            {{ _translateService.currentLang === 'ar' ? item.name : item.name }}
          </option>
        </select>
        <div *ngIf="user_id.invalid && user_id.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.user_required' | translate }}
        </div>
      </div>
    </div>

    <!-- Contract Type -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label required-field">{{ 'MENU.DASHBOARD.contract_type' | translate }}</label>
        <select
          class="form-control"
          [(ngModel)]="formData.contract_type_id"
          name="contract_type_id"
          #contract_type_id="ngModel"
          [class.is-invalid]="contract_type_id.invalid && contract_type_id.touched"
          required
        >
          <option value="" disabled selected>{{ 'MENU.DASHBOARD.select_contract_type' | translate }}</option>
          <option *ngFor="let item of pages" [value]="item.id">
            {{ _translateService.currentLang === 'ar' ? item.name_ar : item.name_en }}
          </option>
        </select>
        <div *ngIf="contract_type_id.invalid && contract_type_id.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.contract_type_required' | translate }}
        </div>
      </div>
    </div>

    <!-- Duration (Months) -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label required-field">{{ 'MENU.DASHBOARD.duration_months' | translate }}</label>
        <select
          class="form-control"
          [(ngModel)]="formData.duration_months"
          name="duration_months"
          #duration_months="ngModel"
          [class.is-invalid]="duration_months.invalid && duration_months.touched"
          required
        >
          <option value="" disabled selected>{{ 'MENU.DASHBOARD.enter_duration' | translate }}</option>
          <!-- <option value="tow-months">{{ 'MENU.DASHBOARD.two_months' | translate }}</option>
<option value="four-months">{{ 'MENU.DASHBOARD.four_months' | translate }}</option> -->
          <option value="monthly">{{ 'MENU.DASHBOARD.monthly' | translate }}</option>
           <option value="tow-months">{{ 'MENU.DASHBOARD.two_months' | translate }}</option>
<option value="four-months">{{ 'MENU.DASHBOARD.four_months' | translate }}</option>
          <option value="quarterly">{{ 'MENU.DASHBOARD.quarterly' | translate }}</option>
          <option value="semi_annually">{{ 'MENU.DASHBOARD.semi_annually' | translate }}</option>
          <option value="annually">{{ 'MENU.DASHBOARD.annually' | translate }}</option>
        </select>
        <div *ngIf="duration_months.invalid && duration_months.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.duration_required' | translate }}
        </div>
      </div>
    </div>

    <!-- Start Date -->
<div class="col-sm-4">
  <div class="mb-3">
    <label class="form-label required-field">
      {{ 'MENU.DASHBOARD.start_date' | translate }}
    </label>

    <input
      type="date"
      class="form-control"
      [(ngModel)]="formData.start_date"
      name="start_date"
      #start_date="ngModel"
      [class.is-invalid]="start_date.invalid && start_date.touched"
      required
    />

    <div *ngIf="start_date.invalid && start_date.touched" class="text-danger small mt-1">
      {{ 'MENU.DASHBOARD.start_date_required' | translate }}
    </div>
    
  </div>
</div>

    <!-- Investment Amount -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label required-field">{{ 'MENU.DASHBOARD.investment_amount' | translate }}</label>
        <input
          type="number"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_investment_amount' | translate }}"
          [(ngModel)]="formData.investment_amount"
          name="investment_amount"
          #investment_amount="ngModel"
          [class.is-invalid]="investment_amount.invalid && investment_amount.touched"
          required
        />
        <div *ngIf="investment_amount.invalid && investment_amount.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.investment_amount_required' | translate }}
        </div>
      </div>
    </div>

    <!-- Investment Rate min-->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label required-field">{{ 'MENU.DASHBOARD.investment_rate_min' | translate }}</label>
        <input
          type="number"
          class="form-control text-center"
          placeholder="{{ 'MENU.DASHBOARD.enter_investment_rate' | translate }}"
          [(ngModel)]="formData.investment_rate"
          name="investment_rate"
          #investment_rate="ngModel"
          [class.is-invalid]="investment_rate.invalid && investment_rate.touched"
          min="0"
          max="100"
          step="0.1"
          required
        />
        <div *ngIf="investment_rate.invalid && investment_rate.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.investment_rate_required' | translate }}
        </div>
      </div>
    </div>

    <!-- Investment Rate max -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label required-field">{{ 'MENU.DASHBOARD.investment_rate_max' | translate }}</label>
        <input
          type="number"
          class="form-control text-center"
          placeholder="{{ 'MENU.DASHBOARD.enter_investment_rate' | translate }}"
          [(ngModel)]="formData.investment_rate_max"
          name="investment_rate_max"
          #investment_rate_max="ngModel"
          [class.is-invalid]="investment_rate_max.invalid && investment_rate_max.touched"
          min="0"
          max="100"
          step="0.1"
          required
        />
        <div *ngIf="investment_rate_max.invalid && investment_rate_max.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.investment_rate_required' | translate }}
        </div>
      </div>
    </div>

    <!-- PDF Upload -->
<div class="col-sm-4">
  <div class="mb-3">
    <label class="form-label">{{ 'MENU.DASHBOARD.upload_pdf' | translate }}</label>
    <input
      type="file"
      class="form-control"
      accept=".pdf"
      (change)="onPdfSelected($event)"
    />
  </div>
</div> 

  </div>

  <!-- Submit -->
  <div class="row">
    <div class="col-sm-4">
      <div class="mb-3 d-flex justify-content-start">
        <button
          type="submit"
          class="btn"
          [disabled]="contractForm.invalid"
          style="background-color: #cca44c !important; color: #fff;"
        >
          {{ 'MENU.DASHBOARD.add' | translate }}
        </button>
      </div>
    </div>
  </div>
</form>

  </div>
</div>
